
import { useEffect } from 'react';

export function SEOStructuredData() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://greenerecolandscaping.com';
    
    // Local Business Schema
    const localBusinessSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "@id": `${siteUrl}/#organization`,
      "name": "Greener Eco Landscaping LLC",
      "description": "Family-owned landscaping and lawn care services in Owings Mills, Maryland. Expert mulching, mowing, cleanups, hardscaping, concrete work, and more.",
      "url": siteUrl,
      "logo": "https://static.readdy.ai/image/c7e9a960a8d98f6675d66fd16b902a96/d6911449641f81f9a11579f3e218d085.png",
      "image": "https://static.readdy.ai/image/c7e9a960a8d98f6675d66fd16b902a96/d6911449641f81f9a11579f3e218d085.png",
      "telephone": "443-398-0720",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Owings Mills",
        "addressRegion": "MD",
        "addressCountry": "US"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 39.4193,
        "longitude": -76.7805
      },
      "areaServed": [
        {
          "@type": "City",
          "name": "Owings Mills",
          "addressRegion": "MD",
          "addressCountry": "US"
        },
        {
          "@type": "State",
          "name": "Maryland",
          "addressCountry": "US"
        }
      ],
      "serviceType": [
        "Landscaping Services",
        "Lawn Care",
        "Lawn Mowing", 
        "Mulching",
        "Yard Cleanup",
        "Hardscaping",
        "Concrete Work",
        "Snow Removal"
      ],
      "priceRange": "$$",
      "openingHours": [
        "Mo-Fr 08:00-18:00",
        "Sa 09:00-17:00"
      ],
      "sameAs": []
    };

    // Website Schema
    const websiteSchema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "@id": `${siteUrl}/#website`,
      "name": "Greener Eco Landscaping LLC",
      "description": "Professional landscaping and lawn care services in Owings Mills, Maryland",
      "url": siteUrl,
      "publisher": {
        "@id": `${siteUrl}/#organization`
      },
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": `${siteUrl}/?s={search_term_string}`
        },
        "query-input": "required name=search_term_string"
      }
    };

    // Service Schema
    const serviceSchema = {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Professional Landscaping Services",
      "description": "Comprehensive landscaping and lawn care services including mowing, mulching, cleanups, hardscaping, and concrete work in Owings Mills, MD",
      "provider": {
        "@id": `${siteUrl}/#organization`
      },
      "areaServed": {
        "@type": "City",
        "name": "Owings Mills",
        "addressRegion": "MD",
        "addressCountry": "US"
      },
      "serviceType": "Landscaping Services",
      "offers": {
        "@type": "Offer",
        "availability": "https://schema.org/InStock",
        "priceCurrency": "USD"
      }
    };

    // WebPage Schema
    const webPageSchema = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "@id": `${siteUrl}/#webpage`,
      "name": "Greener Eco Landscaping LLC - Professional Lawn Care & Landscaping in Owings Mills, MD",
      "description": "Family-owned landscaping and lawn care services in Owings Mills, Maryland. Expert mulching, mowing, cleanups, hardscaping, concrete work, and more.",
      "url": siteUrl,
      "inLanguage": "en-US",
      "isPartOf": {
        "@id": `${siteUrl}/#website`
      },
      "about": {
        "@id": `${siteUrl}/#organization`
      },
      "datePublished": "2024-01-01",
      "dateModified": "2024-12-19"
    };

    // Add all schemas to head
    const schemas = [localBusinessSchema, websiteSchema, serviceSchema, webPageSchema];
    
    schemas.forEach((schema, index) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = `schema-${index}`;
      script.textContent = JSON.stringify(schema);
      
      // Remove existing schema with same ID if present
      const existing = document.getElementById(`schema-${index}`);
      if (existing) {
        existing.remove();
      }
      
      document.head.appendChild(script);
    });

    // Cleanup function
    return () => {
      schemas.forEach((_, index) => {
        const script = document.getElementById(`schema-${index}`);
        if (script) {
          script.remove();
        }
      });
    };
  }, []);

  return null;
}
